import { Autocomplete, FormControl, TextField } from "@mui/material";
import { SkeletonWrapper } from "mui-toolkit/SkeletonWrapper";

import { BASE_ACRES_COMMODITY_NAMES } from "../helpers";

export const BaseAcresCommoditySelect = ({ onChange, isLoading, selected = null }) => {
  const handleChange = (event, newValue) => {
    if (!newValue) {
      return;
    }
    onChange(newValue);
  };
  return (
    <FormControl fullWidth={true}>
      <SkeletonWrapper variant="textfield" sx={{ marginBottom: "20px" }} isLoading={isLoading}>
        <Autocomplete
          multiple={false}
          options={BASE_ACRES_COMMODITY_NAMES}
          getOptionLabel={(option) => option}
          value={selected}
          onChange={handleChange}
          name="commodity_name"
          renderInput={(params) => (
            <TextField
              name="filter_commodity_name"
              {...params}
              label="Commodity"
              error={!selected}
              helperText={!selected ? "Required" : " "}
              InputLabelProps={{ shrink: true }}
              inputProps={{
                ...params.inputProps,
                "data-testid": "base-acres-commodity-dropdown",
              }}
            />
          )}
        />
      </SkeletonWrapper>
    </FormControl>
  );
};
